import type {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import type {ProtelConfig} from "crqlar-react-common/dist/models/integrations/protel/protelConfig.model";
import {ProtelService} from "crqlar-react-common/dist/services/integrations/protel/protel.service";
import StatsImportLogsTable from "../../common/StatsImportLogsTable";

interface Props {
    protelConfigData: UseEntityData<ProtelConfig>
}

const Logs = ({protelConfigData}: Props) => (
    <StatsImportLogsTable
        configId={protelConfigData.item.id}
        getStats={ProtelService.getStats}
        connectorId="protel"
    />
);

export default Logs;
